module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Layout Home  */
(function(fox) {

	fox.registerWidget('Layout_Home', {
		//Widget config
		configure: function(options) {
			this.registerOptions('', {
				pageContainer: '#container',
				widgets: {
					notification: {
						widget: 'NotificationViewer',
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function() {
			if (!fox.isEmpty(fox.getEnv('design.url'))) {
				fox.site.designUrl = fox.getEnv('design.url');
			} else {
				fox.site.designUrl = "http://" + document.location.host;
			}

			this.embedWidget('member', 'Member', {
				container: '#welcome_user',
				zenTemplate: fox.getTemplate('layout_home_member'),
				autoRender: true
			});

			/*this.embedWidget('currentConversationReload', 'Conversation_PeriodicalUpdater', {
				startUpdateEvent: {
					target: fox.Navigator,
					event: 'modified_0',
				}
			});*/

			this.createImg();

			return this.callParent('init', arguments);
		},

		running: function() {
			// this.currentConversationReload = this.requireEmbeddedWidget('currentConversationReload');
			//this.handleEvent(this.requireEmbeddedWidget('topMenu'), 'addedToDom', fox.bind(this.menuState, this));
			// this.handleEvent(fox.Navigator, 'modified_0', fox.bind(this.currentConversationReload.reloadUpdate, this));
		},

		// menuState: function() {
		// 	if (!fox.isEmpty(fox.site.member)) {
		// 		$('.dlmenu').addClass('member');
		// 	} else {
		// 		$('.dlmenu').removeClass('member');
		// 	}

		// },

		// setMenuActive: function(elt) {
		// 	$('.menu_link').each(function(id, menuElt) {
		// 		$(menuElt).removeClass('active');
		// 		}
		// 	);
		// 	$(elt).addClass('active');

		// },

		// logout: function() {
		// 	fox.site.logout();
		// },

		//large background fixing
		insertBg: function (path) {
			document.body.style.backgroundImage = 'url(' + path + ')';
			document.body.parentNode.style.backgroundImage = 'url(' + path + ')';
		},

		createImg: function (callback) {
			// var _this = this,
			// 	img = document.createElement('img');
			// 	img.src = fox.getEnv('design.url') + '/images/bg/bg_body.jpg';


			//img.onload = function () {
			//	_this.insertBg(img.src);
			//}
		}

	}, 'Site_Layout');

})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/main/widget/layout/home.js
// module id = 142
// module chunks = 4